import Select, { components, OptionProps, SingleValueProps, Props as SelectProps } from 'react-select';
import { DropdownStyles } from 'app/components/common/common-styles';
import { TradeType } from 'app/console-api';
import React from 'react';
import {
  DealTradeType,
  DealTradeTypes
} from 'app/components/common/deal-trade-type/deal-trade-type-meta';
import styled from 'styled-components';


const { Option, SingleValue } = components;

const OptionDescription = styled.div(({ theme }) =>
  theme.withMedia({
    color: theme.styleguideColors.contentSecondary,
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '16px'
  })
);


const DropdownOption = (props: OptionProps<DealTradeType, false>) => {
  return (
    <Option {...props}>
      <>
        <div>{props.data.name}</div>
        <OptionDescription>{props.data.dealRequestDescription}</OptionDescription>
      </>
    </Option>
  );
};

const SelectedDropdownValue = (props: SingleValueProps<DealTradeType>) => (
  <SingleValue {...props}>{props.data.name}</SingleValue>
);

interface DealTradeTypeSelectProps extends Partial<SelectProps<DealTradeType, false>> {
  dealType: TradeType;
}

export const DealTradeTypeSelect = ({ dealType, ...restProps }: DealTradeTypeSelectProps) => {
  const selectedValue = DealTradeTypes.find((opt) => dealType === opt.key);

  return (
    <Select<DealTradeType>
      styles={DropdownStyles({ menuMaxHeight: '300px' })}
      options={DealTradeTypes.filter((value) => value.key !== 'internal')}
      value={selectedValue}
      getOptionValue={(option) => option.key}
      getOptionLabel={(option) => option.name}
      placeholder="Select deal type"
      components={{ Option: DropdownOption, SingleValue: SelectedDropdownValue }}
      {...restProps}
    />
  );
};